import React, { useEffect } from 'react'
import { IDefaultEmergencyContact, TEmergencyContactSchema } from '../../../../../api/types'
import { ErrorBoundary } from '@reapitform/utils'
import { EmergencyContactForm } from '../form-emergency-contact'
import { useDefaultEmergencyContactPost } from '../../../../../api/defaults/emergency-contact'
import { Button, ButtonGroup } from '@reapit/elements'
import { Drawer } from '@reapitform/common-ui'

interface IAddEmergencyContactProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  refreshList: (
    data: IDefaultEmergencyContact[] | ((preData: IDefaultEmergencyContact[]) => IDefaultEmergencyContact[]),
  ) => void
}

export const AddEmergencyContact: React.FC<IAddEmergencyContactProps> = ({ isOpen, onOpenChange, refreshList }) => {
  const { isLoading, addEmergencyContact, isSuccess, returnData } = useDefaultEmergencyContactPost()
  const formId = React.useMemo(() => 'form-add-repairers', [])

  const handleClose = () => onOpenChange(false)
  const handleConfirm = (data: TEmergencyContactSchema) => {
    addEmergencyContact(data)
  }

  useEffect(() => {
    if (!isSuccess || !returnData) return

    refreshList((prevData) => [...prevData, returnData])
    handleClose()
  }, [isSuccess, returnData])

  const DrawerFooter = React.useCallback(() => {
    return (
      <ButtonGroup alignment="right">
        <Button intent="default" disabled={isLoading} onClick={handleClose}>
          Cancel
        </Button>
        <Button loading={isLoading} disabled={isLoading} intent="primary" type="submit" form={formId}>
          Add Repairer
        </Button>
      </ButtonGroup>
    )
  }, [isLoading, handleClose])

  return (
    <ErrorBoundary>
      <Drawer
        canDismiss
        isOpen={isOpen}
        title="Add Repairer"
        onDrawerClose={handleClose}
        footerItems={<DrawerFooter />}
      >
        <EmergencyContactForm formId={formId} onSubmit={handleConfirm} />
      </Drawer>
    </ErrorBoundary>
  )
}
